import React from "react";
import PropTypes from 'prop-types';
//styles
import { Wrapper } from "./Button.styles";

//() Implicit return
const Button = ({ text, callback}) => (
    <Wrapper type="button" onClick={callback}>
        {text}
    </Wrapper>
);

Button.prototype = {
    text: PropTypes.string,
    callback: PropTypes.func
}
export default Button;